import { ContentRenderer } from '../base'
import { buildSectionRenderer } from './generic'

export const SectionRenderer = buildSectionRenderer(ContentRenderer)
